import { useQueryClient, useMutation } from 'react-query';

// Our API
import axiosInstance from 'services/API/API';

// Our endpoints
import { removeClientUrl } from 'shared/api-urls';

// Our Query Keys
import {
	ERROR_MESSAGE_DATA,
	CLIENT_REMOVED_DATA,
	FA_DASHBOARD_PAGINATED_SUMMARY
} from 'shared/query-keys';

const useMutateRemoveClient = () => {
	const queryClient = useQueryClient();
	return useMutation(
		async (selectedClientId) => {
			const removeClientUrlWithClientId =
				removeClientUrl + selectedClientId;

			await axiosInstance.patch(removeClientUrlWithClientId);
		},
		{
			onSuccess: async (data) => {
				queryClient.setQueryData(CLIENT_REMOVED_DATA, data);

				// invalidating query which removes the client from the advisors list of clients on the /dashboard page.
				await queryClient.invalidateQueries(
					FA_DASHBOARD_PAGINATED_SUMMARY
				);
			},
			onError: (error) => {
				queryClient.setQueryData(ERROR_MESSAGE_DATA, error.message);
			}
		}
	);
};

export default useMutateRemoveClient;
